import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  id,
  className = ''
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full flex-col items-center justify-center rounded-2xl bg-cta px-5 py-4 text-center text-navy-950 shadow-[0_6px_0_0_#B38900] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-cta-hover hover:shadow-[0_8px_0_0_#B38900] active:translate-y-1 active:shadow-[0_2px_0_0_#B38900] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand/70 sm:py-5 ${className}`} data-id="element-28" data-mp="2fz214mhtqwvi">
      <span className="flex items-center justify-center gap-2 text-[17px] font-black uppercase leading-tight tracking-tight text-balance sm:text-xl" data-id="element-29" data-mp="3cp2k24viij4w">
        <span data-id="element-30" data-mp="38mfqnzj70q5l">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-31" data-mp="1996c71edpxce" />
      </span>
      {sublabel && <span className="mt-1 text-xs font-semibold text-navy-900/80 sm:text-sm" data-id="element-32" data-mp="1i8td7m37514x">{sublabel}</span>}
    </a>;
}